export const ARCHIVE_VERSIONS = {
    DEFAULT: {
        url: process.env.VUE_APP_API_URL,
        color: '#ffa534'
    },
    V1: {
        url: process.env.VUE_APP_ARCHIVE_V1_API_URL,
        color: '#006825'
    },
    V2: {
        url: process.env.VUE_APP_ARCHIVE_0526_API_URL,
        color: '#874901'
    },
    // V3: {
    //     url: '',
    //     color: '#6f2b01'
    // }
}